const prefix = 'LIBRARY_GRATUITY_'

export const LIBRARY_GRATUITY_SUBMIT_FORM_CREATE_ALL_OUTLET = `${prefix}SUBMIT_FORM_CREATE_ALL_OUTLET`

export const LIBRARY_GRATUITY_CANCEL_DELETE_GRATUITY = `${prefix}CANCEL_DELETE_GRATUITY`

export const LIBRARY_GRATUITY_SHOW_DELETE_GRATUITY_MODAL = `${prefix}SHOW_DELETE_GRATUITY_MODAL`

export const LIBRARY_GRATUITY_HIDE_DELETE_GRATUITY_MODAL = `${prefix}HIDE_DELETE_GRATUITY_MODAL`

export const LIBRARY_GRATUITY_ASK_DELETE_GRATUITY = `${prefix}ASK_DELETE_GRATUITY`

export const LIBRARY_GRATUITY_SET_DELETED_GRATUITY = `${prefix}SET_DELETED_GRATUITY`

export const LIBRARY_GRATUITY_SUBMIT_FORM_CREATE = `${prefix}SUBMIT_FORM_CREATE`

export const LIBRARY_GRATUITY_DELETE_GRATUITY = `${prefix}DELETE_GRATUITY`

export const LIBRARY_GRATUITY_SUBMIT_FORM_UPDATE = `${prefix}SUBMIT_FORM_UPDATE`

export const LIBRARY_GRATUITY_ON_CLICK_CANCEL = `${prefix}ON_CLICK_CANCEL`

export const LIBRARY_GRATUITY_PAGE_REQUEST = `${prefix}PAGE_REQUEST`

export const LIBRARY_GRATUITY_SET_OUTLETS = `${prefix}SET_OUTLETS`

export const LIBRARY_GRATUITY_OUTLETS_REQUEST = `${prefix}OUTLETS_REQUEST`

export const LIBRARY_GRATUITY_GRATUITIES_REQUEST = `${prefix}GRATUITIES_REQUEST`

export const LIBRARY_GRATUITY_ON_CLICK_ROW = `${prefix}ON_CLICK_ROW`

export const LIBRARY_GRATUITY_ON_CHANGE_OUTLET_IDS = `${prefix}ON_CHANGE_OUTLET_IDS`

export const LIBRARY_GRATUITY_ON_CLICK_CREATE_GRATUITY = `${prefix}ON_CLICK_CREATE_GRATUITY`

export const LIBRARY_GRATUITY_SET_GRATUITIES = `${prefix}SET_GRATUITIES`

export const LIBRARY_GRATUITY_SET_GRATUITY_DETAIL = `${prefix}SET_GRATUITY_DETAIL`

export const LIBRARY_GRATUITY_SET_CURRENT_PAGE = `${prefix}SET_CURRENT_PAGE`

export const LIBRARY_GRATUITY_SET_TOTAL_PAGE = `${prefix}SET_TOTAL_PAGE`

export const LIBRARY_GRATUITY_OPEN_RIGHT_COLUMN = `${prefix}OPEN_RIGHT_COLUMN`

export const LIBRARY_GRATUITY_CLOSE_RIGHT_COLUMN = `${prefix}CLOSE_RIGHT_COLUMN`

export const LIBRARY_GRATUITY_IS_SUBMITTING_FORM = `${prefix}IS_SUBMITTING_FORM`



// WEBPACK FOOTER //
// ./app/actions/library/gratuity/constants.js